// Reduce a `{ en: [...], heb: [...] }` VirtualTable layout to a phone-friendly
// subset. The fixed pixel column widths that make tables great on desktop force
// horizontal scroll on a 375px screen, so on mobile each page keeps only its
// essential columns and re-widths them to fit.
//
// `widths` maps the dataKeys to keep -> their mobile pixel width. Original
// column order is preserved; every other column is dropped.
export function pickMobileColumns(layout, widths) {
  const pick = (arr) =>
    (arr || [])
      .filter((c) => c.dataKey in widths)
      .map((c) => ({ ...c, width: widths[c.dataKey] }));
  const out = {};
  for (const code of Object.keys(layout || {})) out[code] = pick(layout[code]);
  return out;
}
